<script>
  import { onDestroy } from 'svelte';
  import { fade } from 'svelte/transition';

  import { Icon } from '@client/components/icon';

  import { getNotificationsContext } from './notification.context';

  export let notification = {};

  const { removeNotification } = getNotificationsContext();

  const { id, color, autohide, header, text, component, dismissable = true, type = 'default' } = notification;

  const onRemove = () => removeNotification(id);

  let timeout = null;

  if (autohide) {
    timeout = setTimeout(onRemove, autohide);
  }

  const icons = {
    success: 'os-icon-check',
    error: 'os-icon-x',
    warning: 'os-icon-alert-triangle',
    info: 'os-icon-info'
  };

  onDestroy(() => {
    if (autohide && timeout) {
      clearTimeout(timeout);
    }
  });
</script>

{#if component}
  <svelte:component this={component} {notification} {onRemove} />
{:else}
  <div
    class="notification {type}"
    style="--notification-bg-color: {color};"
    class:compact={!header}
    role="status"
    aria-live="polite"
    in:fade
    out:fade
  >
    {#if header}
      <div class="header">
        <span>{@html header}</span>

        {#if dismissable}
          <button class="close" on:click={onRemove} aria-label="delete notification">
            <Icon name="x" />
          </button>
        {/if}
      </div>
    {/if}
    <div class="body">
      {#if !header && type && icons[type]}
        <i class={icons[type]} />
      {/if}

      <span>{@html text}</span>

      {#if !autohide && !header && dismissable}
        <button class="close" on:click={onRemove} aria-label="delete notification">
          <Icon name="x" />
        </button>
      {/if}
    </div>
  </div>
{/if}

<style lang="scss" src="./notification.scss"></style>
